import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M112 0H0V112H112V0Z",
      fill: "#D7DBF7"
    }, null, -1),
    _createElementVNode("path", {
      d: "M84 46.6667V84C84 86.4754 83.0167 88.8493 81.2663 90.5997C79.516 92.35 77.142 93.3334 74.6667 93.3334H37.3333C34.858 93.3334 32.484 92.35 30.7337 90.5997C28.9833 88.8493 28 86.4754 28 84V28C28 25.5247 28.9833 23.1507 30.7337 21.4004C32.484 19.65 34.858 18.6667 37.3333 18.6667H56V37.3334C56 39.8087 56.9833 42.1827 58.7337 43.933C60.484 45.6834 62.858 46.6667 65.3333 46.6667H84Z",
      fill: "#151F6D"
    }, null, -1),
    _createElementVNode("path", {
      d: "M84 46.6667H65.3333C62.858 46.6667 60.484 45.6834 58.7337 43.933C56.9833 42.1827 56 39.8087 56 37.3334V18.6667L84 46.6667Z",
      fill: "#959FEB"
    }, null, -1)
  ])))
}
export default { render: render }